module.exports = __webpack_public_path__ + "static/people_img27-ad5ff73accf5db6488d28ef3c863c45d.png";